__turbopack_context__.v({
  "h1": "blocks-module-scss-module__chXROq__h1",
  "h2": "blocks-module-scss-module__chXROq__h2",
  "h3": "blocks-module-scss-module__chXROq__h3",
  "h4": "blocks-module-scss-module__chXROq__h4",
  "pullQuote": "blocks-module-scss-module__chXROq__pullQuote",
  "pullQuoteLong": "blocks-module-scss-module__chXROq__pullQuoteLong",
  "quote": "blocks-module-scss-module__chXROq__quote",
});
